export default __webpack_public_path__ + "static/media/logo.7baa0549.png";